import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/ui/dialog.tsx");
